import {
  type NavigateOptions,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { getWhitelabelCustomization } from "common/helpers/utils";

export default function useWorkspaceNavigate() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const originalNavigate = useNavigate();
  const location = useLocation();

  // this function navigates relative to the selected workspaceId id
  // i.e: 'home' becomes workspaces/:workspaceId/home
  // this should NEVER be used as an alternative to Link components
  function relativeNavigate(to: string, options?: NavigateOptions) {
    if (!location.pathname.endsWith(to)) {
      originalNavigate(
        getWhitelabelCustomization() ? to : `/workspaces/${workspaceId}/${to}`,
        options,
      );
    }
  }

  return { relativeNavigate };
}
